import React, { ButtonHTMLAttributes, DetailedHTMLProps, FC, memo, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import CircleLoader from '../circle-loader/index';

enum ButtonStyleVariant {
  BLUE_ROUNDED = 'bg-brand-700 rounded py-3 text-white font-inter font-[550] text-sm',
  DEFAULT_ROUNDED = 'w-fit rounded px-6 py-[10px]',
  NONE = '',
}

export enum ButtonDisableStyle {
  DEFAULT = 'disabled:cursor-default disabled:bg-gray-100 disabled:text-gray-300 disabled:ring-1 disabled:ring-gray-200',
  INACTIVE = 'disabled:bg-gray-50 disabled:ring-gray-100 disabled:ring-1',
  NONE = '',
}

export type ButtonProps = {
  children?: ReactNode;
  disabled?: boolean;
  disabledStyle?: ButtonDisableStyle;
  isLoading?: boolean;
  styleType?: keyof typeof ButtonStyleVariant;
} & DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

const Button: FC<ButtonProps> = memo(
  ({
    children,
    className,
    disabled,
    disabledStyle = ButtonDisableStyle.DEFAULT,
    isLoading,
    onClick,
    styleType = 'BLUE_ROUNDED',
    type,
    ...props
  }) => {
    return (
      <button
        {...props}
        className={twMerge(
          'flex w-full cursor-pointer items-center justify-center rounded',
          disabledStyle,
          ButtonStyleVariant[styleType],
          className,
        )}
        disabled={disabled || isLoading}
        onClick={onClick}
        type={type ?? 'button'}
      >
        {isLoading ? <CircleLoader /> : children}
      </button>
    );
  },
);

Button.displayName = 'Button';

export default Button;
